import reactLogo from 'assets/images/react-logo.svg';
import sassLogo from 'assets/images/sass.svg';
import vueLogo from 'assets/images/vue-logo.svg';
import htmlLogo from 'assets/images/html5.svg';
import cssLogo from 'assets/images/css.svg';
import jsLogo from 'assets/images/javascript.svg';
import tailwindLogo from 'assets/images/tailwind.svg';
import bootstrapLogo from 'assets/images/bootstrap.svg';
import jqueryLogo from 'assets/images/jquery-2.svg';
import pugLogo from 'assets/images/pug.svg';
import phpLogo from 'assets/images/php-logo.png';
import laraveLogo from 'assets/images/laravel.png';
import wordPress from 'assets/images/wordpress.svg';
import mysqSQL from 'assets/images/mysql.svg';
import graphQLLogo from 'assets/images/graphql.svg';
// import oopLogo from 'assets/images/oop.svg';
import restLogo from 'assets/images/rest-api.svg';
import linuxLogo from 'assets/images/linux.svg';
import ubuntuLogo from 'assets/images/ubuntu.svg';
import apacheLogo from 'assets/images/apache.svg';
import nginxLogo from 'assets/images/nginx.svg';

import gitLogo from 'assets/images/git.svg';
import dockerLogo from 'assets/images/docker.svg';
import composerLogo from 'assets/images/composer.svg';
import npmLogo from 'assets/images/npm.svg';
import yarnLogo from 'assets/images/yarn.svg';
import viteLogo from 'assets/images/vite.svg';
import webpackLogo from 'assets/images/webpack.svg';
import postmanLogo from 'assets/images/postman.svg';

const feskills = [
	{
	  title: 'HTML',
	  image: htmlLogo,
	},
	{
	  title: 'CSS',
	  image: cssLogo,
	},
	{
	  title: 'JavaScript',
	  image: jsLogo,
	},
	{
	  title: 'Sass',
	  image: sassLogo,
	},
	{
	  title: 'Tailwind CSS',
	  image: tailwindLogo,
	},
	{
	  title: 'Bootstrap',
	  image: bootstrapLogo,
	},
	{
	  title: 'jQuery',
	  image: jqueryLogo,
	},
	{
	  title: 'Pug',
	  image: pugLogo,
	},
	{
	  title: 'Vue JS',
	  image: vueLogo,
	},
	{
	  title: 'React',
	  image: reactLogo,
	},
];

const beskills = [
	{
		title: 'PHP',
		image: phpLogo,
	},
	{
		title: 'Laravel',
		image: laraveLogo,
	},
	{
		title: 'WordPress',
		image: wordPress,
	},
	{
		title: 'MySQL',
		image: mysqSQL,
	},
	{
		title: 'GraphQL',
		image: graphQLLogo,
	},
	// {
	// 	title: 'OOP',
	// 	image: oopLogo,
	// },
	{
		title: 'REST API',
		image: restLogo,
	},
];

const servers = [
	{
		title: 'Linux',
		image: linuxLogo,
	},
	{
		title: 'Ubuntu',
		image: ubuntuLogo,
	},
	{
		title: 'Apache',
		image: apacheLogo,
	},
	{
		title: 'NGINX',
		image: nginxLogo,
	}
];

const productivity = [
	{
		title: 'Git',
		image: gitLogo,
	},
	{
		title: 'Docker',
		image: dockerLogo,
	},
	{
		title: 'Composer',
		image: composerLogo,
	},
	{
		title: 'NPM',
		image: npmLogo,
	},
	{
		title: 'Yarn',
		image: yarnLogo,
	},
	{
		title: 'Vite',
		image: viteLogo,
	},
	{
		title: 'Webpack',
		image: webpackLogo,
	},
	{
		title: 'Postman',
		image: postmanLogo,
	},
];

export { feskills, beskills, servers, productivity };